import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-field-validation-message',
  templateUrl: './field-validation-message.component.html',
  styleUrls: ['./field-validation-message.component.scss']
})
export class FieldValidationMessageComponent implements OnInit {
  @Input() valid: boolean;
  @Input() showValidationErrors;
  @Input() errorMessage: string;
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/field-validation-message/field-validation-message.component.ts